import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SearchForm } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import { BookingSearchActions } from '../actions';
import { DashboardState, selectLoading, selectSearchForm } from '../reducers/dashboard.reducer';
import { GenericError } from 'src/app/layout/actions/layout.actions';

@Injectable()
export class DashboardService {
  constructor(private store: Store<DashboardState>, private router: Router) {}

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(selectLoading));
  }

  getSearchForm(): Observable<SearchForm> {
    return this.store.pipe(select(selectSearchForm));
  }

  dispatchSubmitSearch(searchForm: SearchForm) {
    this.navigateToPnrInfo(searchForm);
    this.store.dispatch(BookingSearchActions.SubmitSearchForm({ searchForm }));
  }

  dispatchLoadPnrSuccess() {
    this.store.dispatch(BookingSearchActions.LoadItinerary());
  }

  dispatchLoadPnrFail(error: ContractError) {
    this.store.dispatch(GenericError({ error, titleKey: 'error' }));
  }

  navigateToPnrInfo(searchForm: SearchForm) {
    this.router.navigate(['/itinerary/info'], {
      queryParams: { ...searchForm }
    });
  }
}
